import { useNavigate } from "react-router";
import { usePageTitle } from "../ui/usePageTitle";
import styles from "./NotFound.module.css";

const s = {
  title: "Something went wrong.",
  body: "You can try reloading the page, or",
  back: "go back.",
};

/** `/error` and the router's error boundary (shell spec section 8). */
export function ErrorPage() {
  usePageTitle("Error");
  const navigate = useNavigate();
  return (
    <section className={styles.wrap} role="alert">
      <h1 className={styles.title}>{s.title}</h1>
      <p className={styles.line}>
        {s.body}{" "}
        <button type="button" className={styles.linkButton} onClick={() => navigate(-1)}>
          {s.back}
        </button>
      </p>
    </section>
  );
}
